// app-hook.js
import { useReactiveVar } from "@apollo/client";
import { alertQueueRepo, userInfoRepo } from "../value/AppModel";
import { useCallback, useEffect, useState } from "react";
import { ApiMsg, AppStyle } from "../value/AppConst";
import UserSessionInfo from "../value/UserSessionInfo";

export function useAlertSetter() {
    const alertQueue = useReactiveVar(alertQueueRepo);

    return useCallback((alertInfo) => {
        if(!alertInfo) {
            alertInfo = {
                title: '오류',
                message: ['경고메시지 호출이 있으나 알림정보가 없습니다.', '관리자에게 연락 바랍니다.', '(프로그램 오류)'],
                isError: true};
        }
        if(alertInfo.isError === undefined) alertInfo.isError = true;
        let messages = [];
        if(!alertInfo.message) messages.push(alertInfo.title);
        else if(typeof alertInfo.message === 'string') {
            messages = alertInfo.message.split('\n').filter((msg)=>msg.length>0);
        }
        else {
            const old = [...alertInfo.message];
            for(const msg of old) {
                if(typeof msg === 'string') //messages.push(msg.split('\n').filter((msg)=>msg.length>0));
                    msg.split("\n").forEach((m)=>{if(m.length>0) messages.push(m)});
                else messages.push(msg);
            }
        }
        alertInfo.message = messages;

        if(messages[0] === ApiMsg.AUTH_ERROR) {
            userInfoRepo(new UserSessionInfo(true)); // true for sessionChecked.
        }

        const newQueue = [...alertQueue, alertInfo];
        alertQueueRepo(newQueue);
    }, [alertQueue])
}

// Hook
export function useClientSize() {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth, height: window.innerHeight,
        dataAreaHeight: window.innerHeight - AppStyle.AppHeaderHeight - AppStyle.AppViewTabHeight - AppStyle.AppFooterHeight, // - AppNumber.dataContainerPadding * 2,
        dataAreaWidth: window.innerWidth //- AppNumber.dataContainerPadding * 2
    });

    useEffect(()=>{
        function handleResize() {
            setWindowSize({
                width:window.innerWidth,
                height:window.innerHeight,
                dataAreaHeight: window.innerHeight - AppStyle.AppHeaderHeight - AppStyle.AppViewTabHeight - AppStyle.AppFooterHeight, // - AppNumber.dataContainerPadding * 2,
                dataAreaWidth: window.innerWidth //- AppNumber.dataContainerPadding * 2
            });
        }

        window.addEventListener("resize", handleResize);
        // call first time.
        handleResize();

        // Remove event listener on cleanup
        return() => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount

    return windowSize;
}

export function useAuthorizationCheck() {
    const sessionInfo = useReactiveVar(userInfoRepo);
    // Check if user's authClassId is in the authTableTree.tree.proc_name.
    
    return useCallback((job) => {
        if(job && job.allow && job.allow.length>0) {
            return job.allow.includes(sessionInfo.user.authClassInt);
        }
        else {
            if(!job) console.log('useAuthorizationCheck: job is null');
            else if(!job.allow) console.log('useAuthorizationCheck: job.allow is null');
            else console.log('useAuthorizationCheck: job.allow.length is 0');
        }
        return false;
    }, [sessionInfo]);

    /*
    2024.9.24:
    SELECT DISTINCT job_name FROM auth_table ORDER BY job_name;
    
    pr_arrive_info_add
    pr_arrive_info_edit
    pr_arrive_info_remove
    pr_arrive_info_set_auto_plan_order
    pr_arrive_info_set_auto_view_order
    pr_arrive_info_set_usage
    pr_arrive_info_unset_auto_plan_order
    pr_arrive_info_upload
    pr_com_info_set_dc
    pr_com_info_set_usage
    pr_dc_info_add
    pr_dc_info_edit
    pr_dc_info_remove
    pr_dc_info_set_usage
    pr_menu_auth_alloc_add
    pr_menu_auth_alloc_remove
    pr_store_info_add
    pr_store_info_edit
    pr_store_info_remove
    pr_store_info_set_usage
    pr_user_alloc_permit
    pr_user_alloc_remove
    pr_user_bbs_comments_add
    pr_user_bbs_comments_remove
    pr_user_bbs_info_add
    pr_user_bbs_info_set_status
    pr_user_info_add
    pr_user_info_ch_pswd
    pr_user_info_edit
    pr_user_info_remove
    pr_user_info_set_secu_handler
    pr_user_info_set_usage
    pr_user_info_upload
    pr_veh_type_group_add
    pr_veh_type_group_code_add
    pr_veh_type_group_code_edit
    pr_veh_type_group_code_remove
    pr_veh_type_group_edit
    pr_veh_type_group_order_remove
    pr_veh_type_group_order_set
    pr_veh_type_group_remove
    pr_veh_type_info_add
    pr_veh_type_info_edit
    pr_veh_type_info_remove
    */
}
